export type ChallengeTypes = "VC" | "Q" | "M";
export const challengeTypes: Record<ChallengeTypes, string> = {
  VC: "Verse Cards",
  Q: "Questions",
  M: "Memorize",
};

export type ChallengeDifficulties = "H";
export const challengeDifficulties: Record<ChallengeDifficulties, string> = {
  H: "Hard",
};

export type AttemptStatuses = "P" | "F" | "I";
export const attemptStatuses: Record<AttemptStatuses, string> = {
  P: "Passed",
  F: "Failed",
  I: "Incomplete",
};

export interface DailyChallengeDetails {
  day: string;

  // The challenge itself
  challengeType: ChallengeTypes;
  reps: number; // total verses or questions for the challenge
  minPass?: number; // total successes to complete the challenge. If not present, you must complete them all
}
export interface ChallengeMetadata {
  totalAttempts: number;
  totalPasses: number;
  repsComplete?: number[]; // Number of attempts that got each number of reps, if applicable to the challenge
}
export interface DailyChallenge extends DailyChallengeDetails {
  // Details on people who attempted the challenge
  metadata: Record<ChallengeDifficulties, ChallengeMetadata>;
}

export interface ChallengeAttempt extends DailyChallengeDetails {
  // The Attempt
  difficulty: ChallengeDifficulties;
  attemptStatus: AttemptStatuses;
  countCorrect: number;
}

export interface ChallengeStats {
  day: string;
  attemptStatus: AttemptStatuses;
  difficulty: ChallengeDifficulties;
}

export interface ChallengeHistory {
  streak: number;
  longestStreak: number;
  attempts: ChallengeStats[];
}
